// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.GeneralInfoAction.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import { withHandlers } from 'recompose';
import commonMessage from 'share/messages/Izenda.CommonMessages';
import ValidationCategoriesPopup from '../../Izenda.ValidationCategoriesPopup';
import localizer from 'share/localization/Izenda.Localizer';
import constants from 'logic/data/Izenda.RoleSetupConstants';
import { curry, find, flow, toPairs, map, reject, compact, isEmpty } from 'lodash/fp';

const GeneralInfoAction = withHandlers({
  onSave: curry(onSave),
  onCancel: curry(onCancel)
});

/**
 * [onSave]
 * @param  {object} props
 */
function onSave(props, e) {
  const store = props.store;
  e.stopPropagation();
  e.preventDefault();

  props.validation.validate().then(success => {
    if (success) {
      if (store.isDirty) {
        store.validateAccesses().then(result => {
          if (result.success !== false) {
            if (store.roleDetail.isNew) {
              handleSave(props);
            } else {
              props
                .confirmFn('Confirmation', { description: localizer.getText('COMMON_MESSAGES_CONFIRM_SAVE') })
                .then(() => handleSave(props));
            }
          } else {
            props.validation.updateErrors(result.messages);
          }
        });
      } else {
        store.updateAlertMessage(
          commonMessage.MESSAGE_TYPE.INFO,
          localizer.getText('COMMON_MESSAGES_NO_CHANGES_FOUND')
        );
      }
    }
  });
}

/**
 * [handleSave action]
 * @param  {object} props
 */
function handleSave(props) {
  const store = props.store;
  const loader = props.loader;

  loader.startLoading();
  store
    .save()
    .then(messages => {
      const popupMessage = flow(
        toPairs,
        map(pair => {
          const key = pair[0];
          const currentError = find({ key }, messages);
          if (!currentError) {
            return null;
          }
          messages = reject({ key }, messages);
          return currentError;
        }),
        compact
      )(constants.PERMISSION_ERROR);

      if (!isEmpty(popupMessage)) {
        const permissionError = constants.PERMISSION_ERROR[popupMessage[0].key];
        const messageHeader = String.format(
          localizer.getText('ROLE_SETUP_PERMISSION_CATEGORIES_ERROR_HEADER'),
          permissionError.type,
          permissionError.permission
        );
        props.openPopup(ValidationCategoriesPopup, {
          header: messageHeader,
          data: popupMessage[0].detail,
          footer: localizer.getText('ROLE_SETUP_PERMISSION_CATEGORIES_ERROR_FOOTER')
        });
      }

      messages && props.validation.updateErrors(messages);
    })
    .then(loader.endLoading.bind(loader));
}

/**
 * [onCancel]
 * @param  {object} props
 */
function onCancel(props, e) {
  const { loader, store } = props;
  e.stopPropagation();
  e.preventDefault();

  if (store.isDirty) {
    props
      .confirmFn('Confirmation', {
        description: localizer.getText('COMMON_MESSAGES_CONFIRM_CANCEL')
      })
      .then(() => {
        loader.startLoading();
        return store.cancel().finally(loader.endLoading.bind(loader));
      })
      .finally(loader.endLoading.bind(loader));
  } else {
    store.updateAlertMessage(commonMessage.MESSAGE_TYPE.INFO, localizer.getText('COMMON_MESSAGES_NO_CHANGES_FOUND'));
  }
}

export default GeneralInfoAction;



// WEBPACK FOOTER //
// ./ui/modules/Settings/RoleSetup/RoleDetail/Izenda.GeneralInfoAction.js